import { MutationTree } from 'vuex';
import { Hotword, ModuleState, Town, TownNotice } from './types'
import { initialState } from './index'

export const mutations: MutationTree<ModuleState> = {
  handleError(state) {
    state.error = true;
    state.towns = {};
  },
  handleFetchHotwords(state, payload: { hotwords: Hotword[], townId: number }) {
    state.hotwords[payload.townId] = payload.hotwords
  },
  handleFetchNotices(state, payload: { notices: TownNotice[]; townId: number}) {
    state.notices = { ...state.notices, [payload.townId]: payload.notices }
  },
  handleFetchTowns(state, payload: Town[]) {
    const updatedTowns = payload.reduce((towns, town: Town) => {
      towns[town.uniqueName] = town
      return towns
    }, {} as { [key: string]: Town });
    state.towns = updatedTowns;
    state.error = false;
  },
  reset(state) { Object.assign(state, initialState) }
}
